export default (type, payload = null) => ({ type, payload });
